import React from 'react';
import { FormControl, TextField } from '@material-ui/core';
import { CarRegistrationNumberControlProps } from './CarRegistrationNumberControl.interfaces';
import { UtilService } from 'app/services/util.service';
import { ControlContainer } from 'app/components/ControlContainer';
import { DoneAdornment } from 'app/components/DoneAdornment';
import { useCarRegistrationNumberControl } from 'app/shared/hooks/controls/useCarRegistrationNumberControl';

export default function CarRegistrationNumberControl(
  props: CarRegistrationNumberControlProps
) {
  const {
    input,
    input: { value: inputValue },
    meta,
    meta: { touched, valid },
    label,
    tooltip,
    subLabel,
    helperText,
    disabled,
    width,
    isQuestionValid,
  } = props;

  const {
    focused,
    handleBlur,
    handleChange,
    handleClick,
    onFocus,
    maxLength,
  } = useCarRegistrationNumberControl(props);

  return (
    <ControlContainer
      inputId={input.name}
      tooltip={tooltip}
      subLabel={subLabel}
      helperText={helperText}
      isQuestionValid={isQuestionValid}
      meta={meta}
      floating
      floated={focused || UtilService.hasValue(inputValue)}
      focused={focused}
      width={width}
    >
      <FormControl fullWidth>
        <TextField
          {...input}
          id={input.name}
          disabled={disabled}
          onChange={handleChange}
          onBlur={handleBlur}
          onClick={handleClick}
          onFocus={onFocus}
          label={label}
          InputProps={{
            startAdornment: valid &&
              !focused &&
              UtilService.hasValue(inputValue) && <DoneAdornment />,
          }}
          inputProps={{
            maxLength,
          }}
          error={touched && !valid}
          variant={'outlined'}
          margin={'dense'}
          InputLabelProps={{
            shrink: UtilService.hasValue(inputValue) || focused,
          }}
        />
      </FormControl>
    </ControlContainer>
  );
}
